/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Moderationstatusreviewed2Inputs */

const en_moderationstatusreviewed2 = /** @type {(inputs: Moderationstatusreviewed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reviewed`)
};

const de_moderationstatusreviewed2 = /** @type {(inputs: Moderationstatusreviewed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geprüft`)
};

/**
* | output |
* | --- |
* | "Reviewed" |
*
* @param {Moderationstatusreviewed2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const moderationstatusreviewed2 = /** @type {((inputs?: Moderationstatusreviewed2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Moderationstatusreviewed2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_moderationstatusreviewed2(inputs)
	return de_moderationstatusreviewed2(inputs)
});
export { moderationstatusreviewed2 as "moderationStatusReviewed" }